module.exports = __webpack_public_path__ + "img/product-feature-txt-bg1.fc980810.png";